import { chunk, VIDEO_TESTIMONIALS } from '@belong/common';
import { Carousel, VideoPlayer, Text } from '@belong/ui';
import clsx from 'clsx';
import css from './testimonial-videos.module.css';

export function TestimonialVideos() {
  const mobileVideoTestimonialSlides = chunk(VIDEO_TESTIMONIALS, 1);
  const tabletVideoTestimonialSlides = chunk(VIDEO_TESTIMONIALS, 2);

  return (
    <>
      <div className="contents md:hidden">
        <Carousel arrowsOnDots>
          {mobileVideoTestimonialSlides.map((mobileTestimonialSlide, index) => {
            return (
              <div className="flex justify-center" key={index}>
                {mobileTestimonialSlide.map((testimonial) => {
                  return (
                    <div
                      className={clsx(
                        'mr-lg gap-sm px-2sm flex flex-col last:mr-0',
                        css.slide,
                      )}
                      key={testimonial.name}
                    >
                      <VideoPlayer
                        videoSrc={testimonial.videoSrc}
                        posterSrc={testimonial.imgSrc}
                      />
                      <div className="flex flex-col">
                        <Text fontWeight="semibold">{testimonial.name}</Text>
                        <Text>{testimonial.description}</Text>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </Carousel>
      </div>
      <div className="hidden md:contents lg:hidden">
        <Carousel arrowsOnDots>
          {tabletVideoTestimonialSlides.map((mobileTestimonialSlide, index) => {
            return (
              <div
                className="gap-lg flex min-w-full justify-center"
                key={index}
              >
                {mobileTestimonialSlide.map((testimonial) => {
                  return (
                    <div
                      className={clsx('gap-sm flex flex-col', css.slide)}
                      key={testimonial.name}
                    >
                      <VideoPlayer
                        videoSrc={testimonial.videoSrc}
                        posterSrc={testimonial.imgSrc}
                      />
                      <div className="flex flex-col">
                        <Text fontWeight="semibold">{testimonial.name}</Text>
                        <Text>{testimonial.description}</Text>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </Carousel>
      </div>
      <div className="lg:gap-lg hidden lg:container lg:grid lg:grid-cols-4">
        {VIDEO_TESTIMONIALS.map((testimonial) => {
          return (
            <div
              className={clsx('gap-sm flex flex-col', css.desktopSlide)}
              key={testimonial.name}
            >
              <VideoPlayer
                videoSrc={testimonial.videoSrc}
                posterSrc={testimonial.imgSrc}
              />
              <div className="flex flex-col">
                <Text fontWeight="semibold">{testimonial.name}</Text>
                <Text>{testimonial.description}</Text>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
